/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для категории с товарами
   */
  app.Category = app.ItemPageableCollection.extend({

    model: app.Model,
    categoryId: null,
    sortTypes: ['price', '-price', 'rating', 'price-unit', '-price-unit', '-date', 'discount', 'sid', 'name', 'mean_rating'],
    apiEndPoint: '/api/v3/item-search/',

    /** @inheritDoc */
    initialize: function () {
      app.ItemPageableCollection.prototype.initialize.apply(this, arguments);
      if (app.features.is_wholesale_price_sort_enabled) {
        this.sortTypes.push('w-price');
      }
    },

    url: function () {
      return app.entryScriptName + this.apiEndPoint;
    },

    defaults: {
      pageSize: 20,
      sort: 'price',
      viewtype: 'list',
      f: 'null',
      mode: 'server',
      priority_ids: null,
      priority_sids: null,
      priority_parent_ids: null,
    },

    /**
     * @inheritDoc
     */
    setQueryParams: function () {
      var that = this;
      this.queryParams = {
        totalRecords: function () {
          return that.totalPages;
        },
        currentPage: 'page',
        pageSize: 'per-page',
        currency: function () {
          return that.currencyId;
        },
        sort: function () {
          return that.sort;
        },
        f: function () {
          return that.filter;
        },
        with_adult: 1,
        viewtype: function () {
          return that.viewtype;
        },
        priority_ids: function () {
          return that.priority_ids;
        },
        priority_sids: function () {
          return that.priority_sids;
        },
        priority_parent_ids: function () {
          return that.priority_parent_ids;
        },
      };
      if (app.filterPageId) {
        this.queryParams.filter_page_id = app.filterPageId;
      }
      if (app.isNewSearchEnabled) {
        this.queryParams.fields = app.API_SEARCH_FIELDS.join(',');
      }

      switch (app.jsCatalogType) {
        case 'accessories':
          if (app.jsParams) {
            this.queryParams.related_id = function () {
              return app.jsParams.itemId;
            };
          }
          break;
        case 'novelty':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_novelty = 1;
          this.defaults.sort = '-date';

          break;
        case 'novelty_2w':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_novelty_2w = 1;
          this.defaults.sort = '-date';

          break;
        case 'novelty_1m':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_novelty_1m = 1;
          this.defaults.sort = '-date';

          break;
        case 'hit':
          // хиты продаж
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_hit = 1;

          break;
        case 'wb':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.for_wb = 1;

          break;
        case 'trademark':
          this.queryParams.trademark_id = function () {
            return that.categoryId;
          };
          this.queryParams.has_price = 1;

          break;
        case 'series':
          if (app.jsParams && app.jsParams.series_id && (app.jsParams.tree_category_id || app.jsParams.tree_id)) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
            this.queryParams.series_id = app.jsParams.series_id;
          } else {
            this.queryParams.series_id = function () {
              return that.categoryId;
            };
          }

          break;
        case 'sale':
          // скидки
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.has_discount = 1;

          break;
        case 'super-price':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_loco = 1;

          break;
        case 'trademark-category':
          if (app.jsParams && (app.jsParams.tree_category_id || app.jsParams.tree_id)) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
          } else {
            this.queryParams.main_category_id = function () {
              return that.categoryId;
            };

            if (app.jsParams) {
              this.queryParams.trademark_id = app.jsParams.trademark_id;
            }
          }

          break;
        case 'trademark-category-exclusive':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          if (app.jsParams) {
            this.queryParams.trademark_id = app.jsParams.trademark_id;
          }
          break;
        case 'special-offer-category':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };

          if (app.jsParams) {
            this.queryParams.special_offer_id = app.jsParams.special_offer_id;
          }

          break;
        case 'selection':
          this.queryParams.selection_id = function () {
            return that.categoryId;
          };
          this.defaults.viewtype = 'cards';

          break;
        case 'offer':
          if (app.jsParams && app.jsParams.offer_id && (app.jsParams.tree_category_id || app.jsParams.tree_id)) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
            this.queryParams.offer_id = app.jsParams.offer_id;
          } else {
            this.queryParams.offer_id = function () {
              return that.categoryId;
            };
            if (app.jsParams && app.jsParams.category_id) {
              this.queryParams.category_id = app.jsParams.category_id;
            }
          }
          this.defaults.sort = 'discount';
          break;
        case 'gifts':
          this.queryParams.gift_id = function () {
            return that.categoryId;
          };
          this.defaults.sort = 'price';
          break;
        case 'volume-discount':
          if (app.jsParams) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
            if (app.jsParams.category_id) {
              this.queryParams.category_id = app.jsParams.category_id;
            }
          }
          this.queryParams.volume_discount_id = function () {
            return that.categoryId;
          };
          this.defaults.sort = 'price';
          this.defaults.viewtype = 'cards';
          break;
        case 'volume-discount-accumulation':
          if (app.jsParams) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
            if (app.jsParams.category_id) {
              this.queryParams.category_id = app.jsParams.category_id;
            }
          }
          this.queryParams.volume_discount_id_0 = function () {
            return that.categoryId;
          };
          if (!app.isMobile) {
            this.defaults.viewtype = 'cards';
          }
          this.defaults.sort = 'price';
          break;
        case 'volume-discount-granting':
          if (app.jsParams) {
            if (app.jsParams.tree_category_id) {
              this.queryParams.tree_category_id = app.jsParams.tree_category_id;
            }
            if (app.jsParams.tree_id) {
              this.queryParams.tree_id = app.jsParams.tree_id;
            }
            if (app.jsParams.category_id) {
              this.queryParams.category_id = app.jsParams.category_id;
            }
          }
          this.queryParams.volume_discount_id_1 = function () {
            return that.categoryId;
          };
          if (!app.isMobile) {
            this.defaults.viewtype = 'cards';
          }
          if (app.jsParams) {
            this.defaults.sort = app.jsParams.sort;
          }
          break;
        case 'markdown':
          // уценённые товары
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_markdown = 1;
          break;
        case 'wholesale':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_wholesale = 1;
          this.queryParams.enable_wholesale_price = 1;
          break;
        case 'parts':
          delete this.queryParams.category_id;
          break;
        case 'shock-price':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.is_shock_price = 1;
          break;
        case 'uslugi':
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
          this.queryParams.type = '0,1,2';
          break;
        default:
          // каталог
          this.queryParams.category_id = function () {
            return that.categoryId;
          };
      }

      this.queryParams.expand = [
        'small_modifiers',
        'photo_sizes',
        'cart_item',
        'wish_item',
        'attrs',
        'nestedUnit',
        'files',
        'badges',
        'retail_fee_markup',
      ].join(',');
      if (app.isNewSearchEnabled) {
        this.apiEndPoint = '/api/v3/search/';
        this.queryParams.expand += ',special_offer_badge_label';
      }
      if (app.isNewViewModifiersEnabled) {
        this.queryParams.expand += ',item_group';
      }
    },
    /**
     * Устанавливает параметр категории поиска
     * @param {(number|null)} categoryId ID категории поиска
     */
    setCategoryId: function (categoryId) {
      if (categoryId) {
        this.categoryId = categoryId;
      }
    },
  });

})();

}.call(window));